import React, { forwardRef } from "react";
import { FormFeedback, Input, InputProps } from "reactstrap";

type Props = {
    error?: string;
} & Omit<InputProps, "type" | "innerRef">;

export const DatePickerInput = forwardRef<HTMLInputElement, Props>(({
    id,
    error,
    ...rest
}, ref) => {
    const errorMessageId = id ? `${id}-errormessage` : undefined
    return <>
        <Input
            innerRef={ref}
            id={id}
            aria-describedby={error && errorMessageId ? errorMessageId : undefined}
            type="text"
            {...rest}
        />
        {error && <FormFeedback id={errorMessageId || undefined}>{error}</FormFeedback>}
    </>;
});
